import { Component, Input } from '@angular/core';
import { MuiAvatarDisplayType } from './mui-avatar-display-type';

@Component({
  selector: 'mui-avatar',
  templateUrl: './mui-avatar.component.html',
  styleUrls: ['./mui-avatar.component.scss']
})
export class MuiAvatar {
  @Input()
  name?: string;

  @Input()
  avatarUrl?: string;

  @Input() avatarSubIcon?: string;

  @Input()
  size = 'sm';

  availableColors = [
    '#e51c23',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#5677fc',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#259b24',
    '#8bc34a',
    '#afb42b',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b'
  ];

  avatarDisplayTypes = MuiAvatarDisplayType;

  get backgroundColor(): string | null {
    if (!this.initials) {
      return null;
    }
    return `${this.arbitraryElement(this.availableColors, this.initials)}`;
  }

  get displayType(): MuiAvatarDisplayType {
    if (this.avatarUrl) {
      return MuiAvatarDisplayType.AVATAR;
    } else if (this.initials) {
      return MuiAvatarDisplayType.INITIALS;
    } else {
      return MuiAvatarDisplayType.ICON;
    }
  }

  get initials(): string {
    if (this.name) {
      const names = this.name.split(' ');
      return `${names[0]?.substr(0, 1).toUpperCase()}${names[names.length - 1]?.substr(0, 1).toUpperCase()}`;
    }

    return '';
  }

  // I have no idea what this does
  // ToDo: Fix typing here
  private arbitraryElement(arr: string[], seed: any): string {
    const charCodes = seed.split('').reduce((
      a: string,
      b: string,
      i: number
    ) => (i === 1 ? a.charCodeAt(0) : +a) + b.charCodeAt(0));
    return arr[charCodes % arr.length];
  }
}
